import React from 'react';
import bannerCar from '../../common/assets/images/homeBannerCar.png';
import { useNavigate } from 'react-router-dom';

const Banner = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/form_page");
  }
  return (
    <div className="bg-home-banner bg-no-repeat bg-cover bg-bottom relative top-[-120px] overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-[10rem] sm:pt-[12rem] md:pt-[14.063rem] pb-[8rem] sm:pb-[10rem] md:pb-[12.375rem]">
        {/* Subtitle */}
        <h6 className="portLligatSansFont text-lg sm:text-xl tracking-widest pb-3 text-[#051C34] text-center sm:text-left">
          Let's Find Your Perfect Car
        </h6>
        {/* Title */}
        <h1 className="font-light text-[40px] sm:text-[50px] md:text-[60px] lg:text-[70px] text-center sm:text-left">
          “Your Journey{' '}
          <span className="italic font-semibold">Your Confidence”</span>
        </h1>
        {/* Description */}
        <p className="font-medium text-base sm:text-lg leading-6 sm:leading-7 pb-8 sm:pb-12 text-center sm:text-left">
          At Example, we believe that your car-shopping journey should be as
          exciting as the open road itself. With our commitment to expertise,
          transparency, and user empowerment, we're here to turn your automotive
          dreams into a reality. Shop and sell with confidence - choose Example,
          your trusted partner in the world of cars.
        </p>
        {/* Button */}
        <div className="flex justify-center sm:justify-start">
          <button className="darkBlue text-white py-3 px-6 sm:px-[22px]" onClick={handleClick}>
            Start Evaluation
          </button>
        </div>
        <img
          src={bannerCar}
          className='sm:block absolute hidden lg:w-[807px] lg:h-[454px] sm:w-[507px] sm:-right-4 sm:h-[354px] top-[520px] right-[75px] '
          alt=''
        />
      </div>
    </div>
  );
};

export default Banner;
